module.exports = __webpack_public_path__ + "img/fixed-header2.bf3f8e32.png";